import { render, staticRenderFns } from "./QueryClaimMenu.vue?vue&type=template&id=4b956c18&"
import script from "./QueryClaimMenu.vue?vue&type=script&lang=js&"
export * from "./QueryClaimMenu.vue?vue&type=script&lang=js&"
import style0 from "./QueryClaimMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports